module.exports = __webpack_public_path__ + "img/proxy-invoice.e3090ea5.svg";